/* eslint import/prefer-default-export:0 */
const IMAGE_TYPE = 'IMAGE';

const getNotHostedImageCount = (page) => {
    const contentState = page && page.editor_state && JSON.parse(page.editor_state);
    if (!contentState) return 0;

    return Object.values(contentState.entityMap).reduce((count, entity) => {
        if (entity.type === IMAGE_TYPE && entity.data.notHosted) {
            count += 1;
        }
        return count;
    }, 0);
};

const trackPageAnalytics = (title = window.pageTitle, context = 'initialLoad', name = 'Page') => {
    try {
        const { href: url, pathName } = window.location;
        const analyticsProperties = {
            context,
            name,
            path: pathName,
            referrer: url.split('/').slice(0, 5).join('/'),
            title,
            url,
        };

        if (window.page) {
            analyticsProperties.notHostedImageCount = getNotHostedImageCount(window.page);
        }

        window.analytics.page(name, analyticsProperties);
    } catch (e) {
        console.error('Error: posting analytics', e);
    }
};

const canUseAnalytics = () => typeof window.analytics?.track === 'function';

const trackAndExecute = (eventName, eventProperties, eventOptions, callback) => {

    if (canUseAnalytics()) {
        // We need to wrap this in a promise.all as privacy blocking software, e.g privacy badger will modify the window.analytics functions to not work silently
        return Promise.all([window.analytics.track(eventName, eventProperties, eventOptions)])
            .finally(callback)
    }

    return callback();
};

export {
    trackPageAnalytics,
    trackAndExecute,
};
